import { EyeOutlined } from '@ant-design/icons';
import { Button, Modal, Typography } from 'antd';
import { useState } from 'react';
import './ImageGallery.scss';

const { Text } = Typography;

const ImageGallery = ({ images = [], title = "Изображения инициативы" }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  if (!images || images.length === 0) {
    return null;
  }

  // Нормализация URL изображений
  const normalizeImageUrl = (url) => {
    if (!url) return url;
    
    // Если URL относительный, добавляем базовый путь
    if (url.startsWith('/media/')) {
      return `https://law.fishrungames.com${url}`;
    }
    
    // Если URL использует law.fishrungames.com, нормализуем его
    if (url.includes('law.fishrungames.com')) {
      return url
        // Заменяем http:// на https://
        .replace('http://law.fishrungames.com', 'https://law.fishrungames.com')
        // Заменяем api.law.fishrungames.com на law.fishrungames.com
        .replace('https://api.law.fishrungames.com', 'https://law.fishrungames.com')
        .replace('http://api.law.fishrungames.com', 'https://law.fishrungames.com');
    }
    
    return url;
  };

  const handlePreview = (image, index) => {
    const normalizedUrl = normalizeImageUrl(image.image);
    setPreviewImage(normalizedUrl);
    setPreviewTitle(`${title} - ${index + 1}`);
    setPreviewVisible(true);
  };

  const handleClosePreview = () => {
    setPreviewVisible(false);
    setPreviewImage('');
    setPreviewTitle('');
  };

  return (
    <div className="image-gallery">
      <div className="gallery-header">
        <Text strong>{title}</Text>
        <Text type="secondary" className="gallery-count">
          ({images.length} изображений)
        </Text>
      </div>
      
      <div className="gallery-grid">
        {images.map((image, index) => {
          const normalizedUrl = normalizeImageUrl(image.image);
          return (
            <div key={image.id} className="gallery-item">
              <div className="image-container">
                <img
                  src={normalizedUrl}
                  alt={`${title} ${index + 1}`}
                  className="gallery-image"
                  onClick={() => handlePreview(image, index)}
                  onError={(e) => {
                    console.error('Ошибка загрузки изображения:', normalizedUrl);
                    e.target.style.display = 'none';
                  }}
                />
              <div className="image-overlay">
                <Button
                  type="primary"
                  icon={<EyeOutlined />}
                  size="small"
                  onClick={() => handlePreview(image, index)}
                  className="preview-button"
                >
                  Просмотр
                </Button>
              </div>
            </div>
            <div className="image-info">
              <Text type="secondary" className="image-order">
                Изображение {index + 1}
              </Text>
            </div>
          </div>
        );
        })}
      </div>

      <Modal
        open={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleClosePreview}
        width="auto"
        centered
      >
        <img
          alt={previewTitle}
          style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          src={previewImage}
        />
      </Modal>
    </div>
  );
};

export default ImageGallery;
